import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import './agenda.css';
import { agenda } from '../../json/agenda';

const Agenda = () => {
    const [events, setEvents] = useState([]);
    const [modalStatus, setModalStatus] = useState(false);
    const [eventData, setEventData] = useState([]);

    useEffect(() => {
        setEvents(agenda);
        window.scrollTo(0, 0);
    }, []);

    const handleEventClick = (eventClickInfo) => {
        setModalStatus(true);
        const eventTitle = eventClickInfo.event.title;
        const eventPlace = eventClickInfo.event.extendedProps.place;
        const eventDescription = eventClickInfo.event.extendedProps.description;
        setEventData([eventTitle, eventPlace, eventDescription]);
    };

    const calendarOptions = {
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        weekends: true,
        events: events,
        eventClick: handleEventClick 
    };

    return (
        <div id='calendar'>
            <div className='container'>
                <div className='row'>
                    <div className="col-12">
                        <h3 className='title'>Agenda de la Secretaria</h3>
                        <hr className='hr-gob'/>
                    </div>

                    {modalStatus && (
                        /* Capa oscura que bloquea el fondo */
                        <div className='modal-agenda-overlay' onClick={() => setModalStatus(false)}>
                            <div id='modal-agenda' onClick={(e) => e.stopPropagation()}>
                                
                                {/* EL BOTÓN DE CERRAR: onClick ahora está en el DIV para mayor seguridad */}
                                <div className='close-icon' onClick={() => setModalStatus(false)}>
                                    <i className="fa-sharp fa-solid fa-xmark"></i>
                                    {/* Si el icono de arriba falla, esto aparecerá como respaldo */}
                                    <span className="fallback-x">×</span>
                                </div>
                                
                                <p className='agenda-title'>{ eventData[0] }</p>
                                <p className='agenda-location'>
                                    <i className="fa-solid fa-location-dot"></i> { eventData[1] }
                                </p>
                                <iframe className='twitter-embed' srcDoc={eventData[2]} title="Tweet"></iframe>
                            </div>
                        </div>
                    )}

                    <div className='container'>
                        <div className="agenda">
                            <FullCalendar {...calendarOptions} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Agenda;